import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

class ModifierService extends BaseRepository {
  public collection = 'products/modifiers';
  public version = 'v1';

  public async modifiersProducts(params: GenericMethod) {
    return this.request({...params, url: 'list_in_products'});
  }
  public async retrieveModifierWithOneLevel(params: GenericMethod) {
    return this.request({...params, url: 'retrieve_options_level_one'});
  }
}

export default new ModifierService(axiosInstance);
